import { Modal } from "react-bootstrap";
import "./files.scss";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import cross from "../../images/cross.svg";
import { baseUrl } from "../../stores/main";
import ShowDocument from "../Modals/ShowDocument/index";

const DownloadFiles = ({
  files,
  documentUrl,
  setOpenModalDocument,
  setDocumentUrl,
  openModalDocument,
  ...props
}) => {
  const dictFiles = toJS(files);

  const filesList = (
    <>
      {Object.keys(dictFiles).map((key) => {
        return (
          <a
            className="info-modal-link"
            target="_blank"
            onClick={() => {
              setOpenModalDocument(true);
              setDocumentUrl(`${baseUrl}${dictFiles[key]["file_path"]}`);
            }}
            key={dictFiles[key]["file_name"]}
          >
            {dictFiles[key]["file_name"]}
          </a>
        );
      })}
    </>
  );

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body className="info-modal">
        <p>
          <img
            src={cross}
            className="info-modal-img"
            onClick={props.onHide}
            alt=""
          />
        </p>
        <div className="info-modal-main">
          <p className="info-modal-text info-modal-list"> {filesList}</p>
        </div>
      </Modal.Body>
      <ShowDocument
        show={openModalDocument}
        onHide={() => setOpenModalDocument(false)}
        documentUrl={documentUrl}
      />
    </Modal>
  );
};

export default inject(({ documentsStore, filesStore }) => {
  const {
    documentUrl,
    setOpenModalDocument,
    setDocumentUrl,
    openModalDocument
  } = filesStore;

  const { files, getFiles, error, isLoading } = documentsStore;
  return {
    files,
    getFiles,
    error,
    isLoading,
    documentUrl,
    setOpenModalDocument,
    setDocumentUrl,
    openModalDocument
  };
})(observer(DownloadFiles));
